// removed by extract-text-webpack-plugin
module.exports = {"square":"Square__square__2jXQk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Square/Square.css
// module id = 22
// module chunks = 0